// Este componente puede moverse a src/features/sobremi/SobreMi.jsx para modularizar.
import React from "react";
import "./sobremi.css";

export default function SobreMi() {
  const certificados = [
    {
      id: 1,
      titulo: "Personal Trainer Nacional",
      subtitulo: "IFBB · 2021",
      descripcion:
        "Certificación nacional otorgada por la IFBB, enfocada en entrenamiento personalizado, planificación de rutinas, fuerza, acondicionamiento físico y prevención de lesiones.",
      img: "/images/sobremi/sobremi3.webp",
    },
    {
      id: 2,
      titulo: "Instructorado en GAP",
      subtitulo: "IFBB · 2021",
      descripcion:
        "Entrenamiento específico de glúteos, abdominales y piernas, orientado a mejorar la fuerza, la resistencia y la tonificación muscular.",
      img: "/images/sobremi/sobremi4.webp",
    },
    {
      id: 3,
      titulo: "Preparador Físico para Deportes",
      subtitulo: "IFBB · 2023",
      descripcion:
        "Preparación física aplicada a distintos deportes, enfocada en rendimiento, fuerza, resistencia y prevención de lesiones.",
      img: "/images/sobremi/sobremi2.webp",
    },
    {
      id: 4,
      titulo: "Curso de Ayuno Intermitente",
      subtitulo: "IFBB · 2023",
      descripcion:
        "Formación orientada a la aplicación del ayuno intermitente como estrategia nutricional, considerando beneficios, cuidados y adaptación según objetivos.",
      img: "/images/sobremi/sobremi1.webp",
    },
  ];

  return (
    <section className="sobre-mi">
      <header className="sobre-mi-header">
        <h1>Sobre Mí</h1>
        <p>
          Hola, soy <strong>Cecilia Machuca</strong>, entrenadora y nutricionista
          internacional. Mi enfoque combina entrenamiento y nutrición para lograr
          resultados reales y sostenibles.
        </p>

        {/* Mención a los certificados */}
        <p className="certificados-intro">
          A continuación, te presento mis certificaciones profesionales, que
          respaldan mi formación y experiencia en el área del entrenamiento y la
          nutrición.
        </p>
      </header>

      <div className="certificados-column">
        {certificados.map((cert) => (
          <article key={cert.id} className="certificado-card">
            <div className="certificado-img">
              <img src={cert.img} alt={cert.titulo} />
            </div>

            <div className="certificado-info">
              <h3>{cert.titulo}</h3>
              <span className="certificado-sub">{cert.subtitulo}</span>
              <p>{cert.descripcion}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
